<h1 matDialogTitle>Confirm</h1>

<mat-dialog-content>{{ confirmMessage }}</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button class="mat-accent mr-16" (click)="dialogRef.close(true)">
    <span>Confirm</span>
  </button>

  <button mat-button (click)="dialogRef.close(false)">
    <span>Cancel</span>
  </button>
</mat-dialog-actions>
